module.exports = __webpack_public_path__ + "img/pearl_krabs.bcd099da.jpg";